import React from "react";
import Container from "../components/wrapper/container.wrapper";
import {RouteObject} from "react-router-dom";

export const FallBackRouter = (): RouteObject => (
    {
        path: "*",
        element: <Container/>,
        loader: async () => {
            window.location.href = '/';
        }

    }
)